import { Box, Link, Typography, useTheme } from '@mui/material';
import rplusLogo from '../../assets/images/logos/reputationplus.png';
import React, { FC, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { LocalTranslationContext } from '../../hooks/useLocalTranslation';

interface Props {
  privacyPolicyLink: string;
  imprintLink: string;
  company: string;
}

const SurveyFooter: FC<Props> = ({ privacyPolicyLink, imprintLink, company }) => {
  const theme = useTheme();

  const localContext = useContext(LocalTranslationContext);
  const { t: globalT } = useTranslation();
  const t = localContext ? localContext.t : globalT;

  const useSpaceBetween = imprintLink || privacyPolicyLink;

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        mt: 'auto',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: useSpaceBetween ? 'space-between' : 'space-between',
          alignItems: 'center',
          gap: theme.spacing(1),
          minWidth: 'auto',
          maxWidth: '85.375rem',
          width: '100%',
          borderTop: `1px solid ${theme.palette.divider}`,
          px: theme.spacing(3),
          py: theme.spacing(2),
        }}
      >
        {company && (
          <Typography variant="caption">
            &#169;{` ${new Date().getFullYear()} ${company}`}
          </Typography>
        )}
        <Box
          sx={{ display: 'flex', alignItems: 'center', gap: theme.spacing(1), flexWrap: 'wrap' }}
        >
          {imprintLink && (
            <Link
              variant="caption"
              href={imprintLink}
              underline="none"
              target="_blank"
              rel="noreferrer"
            >
              {t('imprint')}
            </Link>
          )}
          {imprintLink && privacyPolicyLink && <Typography variant="caption">|</Typography>}
          {privacyPolicyLink && (
            <Link
              variant="caption"
              href={privacyPolicyLink}
              underline="none"
              target="_blank"
              rel="noreferrer"
            >
              {t('privacy')}
            </Link>
          )}
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: theme.spacing(1) }}>
          <Typography variant="caption">Powered by:</Typography>
          <Link
            variant="caption"
            href="https://reputation.plus/"
            underline="none"
            target="_blank"
            rel="noreferrer"
          >
            <img
              src={rplusLogo}
              style={{
                maxHeight: theme.spacing(3),
              }}
              alt="reputativ GmbH Logo"
            />
          </Link>
        </Box>
      </Box>
    </Box>
  );
};

export default SurveyFooter;
